import { BaseTelemetryService } from './telemetry';

const SEGMENT_KEY = window.joyEnv && window.joyEnv.JOY_CONFIG_SEGMENT_WRITE_KEY ? window.joyEnv.JOY_CONFIG_SEGMENT_WRITE_KEY : '2xZJ98aly8fmfFDB9msDQlXsyVGVpUby'; // DEV

class SegmentService implements BaseTelemetryService {
  public name: string = 'segment';

  public init() {
    return new Promise((resolve, reject) => {
      const analytics = ((window as any).analytics = (window as any).analytics || []);
      if (analytics.initialize) {
        console.log('inited');
        return resolve('segment');
      }
      if (analytics.invoked) {
        if ((window as any).console && console.error) {
          console.error('Segment snippet included twice.');
        }
        return resolve();
      } else {
        analytics.invoked = true;
        analytics.methods = [
          'trackSubmit',
          'trackClick',
          'trackLink',
          'trackForm',
          'pageview',
          'identify',
          'reset',
          'group',
          'track',
          'ready',
          'alias',
          'debug',
          'page',
          'once',
          'off',
          'on'
        ];
        analytics.factory = function (t: any) {
          return function () {
            const e = Array.prototype.slice.call(arguments);
            e.unshift(t);
            analytics.push(e);
            return analytics;
          };
        };
        for (let t = 0; t < analytics.methods.length; t++) {
          const e = analytics.methods[t];
          analytics[e] = analytics.factory(e);
        }
        analytics.load = (t: any) => {
          const e = document.createElement('script');
          e.type = 'text/javascript';
          e.async = true;
          e.src =
            ('https:' === document.location!.protocol ? 'https://' : 'http://') +
            'cdn.segment.com/analytics.js/v1/' +
            t +
            '/analytics.min.js';
          const n: HTMLScriptElement = document.getElementsByTagName('script')[0];
          n.parentNode!.insertBefore(e, n);
          analytics.page();
          e.onload = () => {
            resolve('segment');
          };
        };
        analytics.SNIPPET_VERSION = '4.0.0';
        analytics.load(SEGMENT_KEY);
      }
    });
  }

  public sendEvent(event: any) {
    if (event.type && event.type === 'page') {
      this._sendPage(event);
    } else {
      this._sendEvent(event);
    }
  }

  public setUser = (userId: string) => {
    (window as any).analytics.identify('google-apps|corrigan@withjoy.com', (data: any) => console.log(data));
  };

  public destroy() {
    return;
  }

  private _sendEvent = (event: any) => {
    (window as any).analytics.track(event.action, event);
  }

  private _sendPage = (event: any) => {
    delete event.type;
    (window as any).analytics.page(event.name, event);
  }
}

export const segmentService = new SegmentService();
